import styled from 'styled-components'
import { Image, Container, Segment, Card } from 'semantic-ui-react'

import { BasedBodyContainer, BasedFullWidthBackgroundContainer, CustomCardGroup } from '@/components/OtherCustomComponents/style'

export const BodyContainer = styled(BasedBodyContainer)`
    & .list.bulleted>.item:before {
        color: #bd3054;
    }
`

export const FullWidthBackgroundContainer = styled(BasedFullWidthBackgroundContainer)`
    background-color: #fdf3f5;
`

export const ThemedText = styled.span`
    color: #bd3054;
`

export const BodySegment = styled(Segment)`
    && {
        font-size: 1em;
        /* margin: -1em; */
    }
`

export const IconsWrapper = styled.div`
    @media (min-width: 992px) {
        padding: 1em;
    }
    &>* {
        margin-bottom: 1em;
    }
`

export const CenterText = styled.div`
    text-align: center;
`
export const ListItem = styled.div`
    display: flex;
`

export const TextRight = styled.p`
    text-align: right;
`

export const VerticalDate = styled.div`
    writing-mode: vertical-lr;
    vertical-align: middle;
    text-align: center;
    transform: rotate(180deg);
    color: #fff;
    background: #bd3054;
    border-radius: 0.1818rem;
    width: 1.5em;
    margin-right: .5em;
`

export const Content = styled.div`
    padding: .5em 0;
    margin: auto 0;
    &>div>*:first-child{
        margin-right: .5em;
    }
    font-size: 18px;
`
export const LeftBorderedSegment = styled.div`
    border-left: 3px solid #bd3054;
    padding-left: .3em;
    height: 100%;

`
export const LeftBorderedSegmentList = styled(LeftBorderedSegment)`
    height: auto;
    &~div {
        margin-top: .5em;
    }
`

export const ScheduleCardGroup = styled(CustomCardGroup)`
    &&&&{
        display: flex !important;
        line-height: 1.3em;
        &>.ui.card {
            @media (max-width: 767px) {
                margin-bottom: 0;
                &:nth-of-type(2n) {
                    order: 2;
                }
            }
        }
    }

`